import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Accordion as BaseAccordion } from '@base-ui-components/react';
import { breakpoints } from "../../tokens/size";
import React from 'react';
const classes = {
    panel: {
        boxSizing: 'border-box',
        overflow: 'hidden',
        height: 'var(--accordion-panel-height)',
        transition: 'height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        '&[data-starting-style], &[data-ending-style]': {
            height: 0,
        },
    },
    content: {
        padding: '1.2rem 1.6rem',
        [`@media (max-width: ${breakpoints.sm})`]: {
            padding: '0.8rem 1.6rem',
        },
    },
};
/**
 * Contains the collapsible content for an Accordion.
 */
export const AccordionPanel = React.forwardRef(({ children, ...props }, ref) => (_jsx(BaseAccordion.Panel, { css: classes.panel, ...props, children: _jsx("div", { ref: ref, css: classes.content, children: children }) })));
